<div class="flex flex-col live-photo-recapture-modal">
    <h2 mat-dialog-title class="!text-xl !font-bold !mb-2 !pb-2">
        <ng-container *ngIf="data.mode === 'teacher'">
            <span translate>examination.recapture.teacher.title</span>
        </ng-container>
        <ng-container *ngIf="data.mode === 'student'">
            <span translate>examination.recapture.student.title</span>
        </ng-container>
    </h2>

    <mat-dialog-content class="!px-4 !py-2 min-h-[560px] max-h-[85vh] overflow-y-auto">

        <!-- ============================================================== -->
        <!-- TEACHER : carte d'instructions                                  -->
        <!-- ============================================================== -->
        <div *ngIf="data.mode === 'teacher'"
             class="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <p class="text-blue-900 font-semibold text-base mb-1"
               translate>
                examination.recapture.teacher.instructions.title
            </p>
            <ul class="text-sm text-blue-700 space-y-0.5 ml-3 list-disc">
                <li translate>examination.recapture.teacher.instructions.line-1</li>
                <li translate>examination.recapture.teacher.instructions.line-2</li>
            </ul>
        </div>

        <!-- ============================================================== -->
        <!-- TEACHER : LIVE — flux distant + spectre + bouton Capturer       -->
        <!-- ============================================================== -->
        <div *ngIf="data.mode === 'teacher' && viewMode() === 'live'"
             class="flex flex-col items-center justify-center mb-3">

            <div class="relative w-80 h-80 overflow-hidden border-2 border-blue-500 rounded-lg shadow-lg bg-gray-900">
                <video #liveVideo
                       class="w-full h-full object-cover"
                       autoplay
                       playsinline
                       muted></video>
                <img class="absolute top-0 left-0 w-full h-full opacity-40 pointer-events-none"
                     src="assets/images/spectre.png"
                     alt="">
            </div>

            <button mat-flat-button
                    color="primary"
                    class="mt-3 w-80"
                    (click)="capture()"
                    [disabled]="capturing()">
                <mat-icon>photo_camera</mat-icon>
                <span class="ml-2" *ngIf="!capturing()" translate>
                    examination.recapture.teacher.live.cta
                </span>
                <span class="ml-2" *ngIf="capturing()" translate>
                    examination.recapture.teacher.live.capturing
                </span>
            </button>

            <span *ngIf="uploadError()"
                  class="mt-2 text-red-600 text-sm"
                  [translate]="uploadError()"></span>
        </div>

        <!-- ============================================================== -->
        <!-- TEACHER : REVIEW — éditeur (zoom/rotation) + aperçu rond        -->
        <!-- ============================================================== -->
        <div *ngIf="data.mode === 'teacher' && viewMode() === 'review'"
             class="w-full">
            <h3 class="font-semibold mb-2 text-lg text-center"
                translate>
                examination.recapture.teacher.review.title
            </h3>

            <div class="flex flex-col md:flex-row gap-4">
                <!-- Editor : ngx-image-cropper -->
                <div class="flex-1 space-y-2">
                    <div class="relative rounded-lg overflow-hidden bg-slate-100 max-w-sm mx-auto">
                        <image-cropper
                            *ngIf="capturedFile()"
                            [imageFile]="capturedFile()"
                            [maintainAspectRatio]="true"
                            [aspectRatio]="1"
                            [roundCropper]="true"
                            format="jpeg"
                            [transform]="transform"
                            [cropperMinWidth]="150"
                            [canvasRotation]="canvasRotation"
                            (imageCropped)="onCropped($event)">
                        </image-cropper>
                    </div>

                    <div class="flex gap-2 items-center justify-center">
                        <span class="text-sm font-semibold" translate>
                            examination.recapture.teacher.review.zoom
                        </span>
                        <button mat-icon-button
                                (click)="onZoomChange(zoom() - 0.1)"
                                [disabled]="zoom() <= 1">
                            <mat-icon>remove_circle_outline</mat-icon>
                        </button>
                        <mat-slider class="flex-1 max-w-xs"
                                    [min]="1"
                                    [max]="3"
                                    [step]="0.1"
                                    discrete>
                            <input matSliderThumb
                                   [value]="zoom()"
                                   (valueChange)="onZoomChange($event)" />
                        </mat-slider>
                        <button mat-icon-button
                                (click)="onZoomChange(zoom() + 0.1)"
                                [disabled]="zoom() >= 3">
                            <mat-icon>add_circle_outline</mat-icon>
                        </button>
                    </div>

                    <div class="flex gap-2 items-center justify-center">
                        <span class="text-sm font-semibold" translate>
                            examination.recapture.teacher.review.rotation
                        </span>
                        <button mat-stroked-button
                                (click)="rotateLeft()"
                                [attr.aria-label]="'examination.recapture.teacher.review.rotate-left' | translate">
                            <mat-icon>rotate_left</mat-icon>
                        </button>
                        <button mat-stroked-button
                                (click)="rotateRight()"
                                [attr.aria-label]="'examination.recapture.teacher.review.rotate-right' | translate">
                            <mat-icon>rotate_right</mat-icon>
                        </button>
                    </div>
                </div>

                <!-- Preview rond + spectre superposé -->
                <div class="flex-1 flex flex-col items-center justify-center">
                    <h4 class="font-semibold text-base mb-2" translate>
                        examination.recapture.teacher.review.preview-label
                    </h4>
                    <div class="relative w-56 h-56">
                        <img *ngIf="croppedPreviewUrl()"
                             [src]="croppedPreviewUrl()"
                             class="w-56 h-56 rounded-full border-2 border-green-500 object-cover shadow-lg bg-slate-100"
                             alt="">
                        <img class="w-56 h-56 rounded-full border-2 border-green-500 absolute top-0 left-0 opacity-40 pointer-events-none"
                             src="assets/images/spectre.png"
                             alt="">
                    </div>
                    <p class="text-sm text-slate-600 text-center mt-2 max-w-xs"
                       translate>
                        examination.recapture.teacher.review.preview-hint
                    </p>
                </div>
            </div>

            <span *ngIf="uploadError()"
                  class="block mt-2 text-center text-red-600 text-sm"
                  [translate]="uploadError()"></span>

            <div class="flex gap-3 mt-3 justify-center">
                <button mat-stroked-button
                        color="warn"
                        (click)="retake()">
                    <span translate>examination.recapture.teacher.review.retake</span>
                </button>
                <button mat-flat-button
                        color="primary"
                        (click)="validate()">
                    <span translate>examination.recapture.teacher.review.validate</span>
                </button>
            </div>
        </div>

        <!-- ============================================================== -->
        <!-- TEACHER : UPLOADING                                             -->
        <!-- ============================================================== -->
        <div *ngIf="data.mode === 'teacher' && viewMode() === 'uploading'"
             class="flex flex-col items-center justify-center py-12">
            <mat-spinner [diameter]="56"></mat-spinner>
            <p class="mt-3 text-base text-slate-700"
               translate>
                examination.recapture.teacher.uploading
            </p>
        </div>

        <!-- ============================================================== -->
        <!-- STUDENT : carte d'infos + cam locale en cadre rond + spectre    -->
        <!-- ============================================================== -->
        <div *ngIf="data.mode === 'student'" class="flex flex-col items-center">

            <div class="w-full mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                <p class="text-blue-900 font-semibold text-base mb-1"
                   translate>
                    examination.recapture.student.subtitle
                </p>
                <p class="text-sm text-blue-700"
                   translate>
                    examination.recapture.student.instructions
                </p>
            </div>

            <div class="relative w-72 h-72 rounded-full overflow-hidden border-2 border-blue-500 shadow-lg bg-gray-900">
                <!-- Photo finale validée par la formatrice (prioritaire) -->
                <img *ngIf="finalPhotoUrl()"
                     [src]="finalPhotoUrl()"
                     class="w-full h-full object-cover"
                     alt="">
                <!-- Photo "figée" envoyée juste après la capture -->
                <img *ngIf="!finalPhotoUrl() && frozenPhotoUrl()"
                     [src]="frozenPhotoUrl()"
                     class="w-full h-full object-cover"
                     alt="">
                <!-- Sinon flux cam local pour aider l'élève à se positionner -->
                <video #liveVideo
                       *ngIf="!finalPhotoUrl() && !frozenPhotoUrl()"
                       class="w-full h-full object-cover"
                       autoplay
                       playsinline
                       muted></video>
                <img class="absolute top-0 left-0 w-full h-full opacity-40 pointer-events-none"
                     src="assets/images/spectre.png"
                     alt="">
            </div>

            <p class="text-sm text-slate-600 text-center mt-2 max-w-xs"
               *ngIf="!finalPhotoUrl() && !frozenPhotoUrl()"
               translate>
                examination.recapture.student.local-preview-hint
            </p>
            <p class="text-sm text-slate-600 text-center mt-2 max-w-xs"
               *ngIf="frozenPhotoUrl() && !finalPhotoUrl()"
               translate>
                examination.recapture.student.frozen-hint
            </p>
            <p class="text-sm text-green-700 font-semibold text-center mt-2 max-w-xs"
               *ngIf="finalPhotoUrl()"
               translate>
                examination.recapture.student.validated-hint
            </p>

            <div class="mt-4 flex items-center gap-3" *ngIf="!finalPhotoUrl()">
                <mat-spinner [diameter]="20"></mat-spinner>
                <span class="text-sm text-slate-600"
                      translate>
                    examination.recapture.student.waiting
                </span>
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end" *ngIf="data.mode === 'teacher' && viewMode() !== 'uploading'">
        <button mat-button (click)="cancel()">
            <span translate>examination.recapture.teacher.cancel</span>
        </button>
    </mat-dialog-actions>
</div>
